function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.924,6.032A9.365,9.365,0,0,0,26.384.885,7.543,7.543,0,0,0,20.5.374a9.454,9.454,0,0,0-4.75,4.216A9.452,9.452,0,0,0,11,.374,7.543,7.543,0,0,0,5.107.885,9.366,9.366,0,0,0,.567,6.032a10.189,10.189,0,0,0,.2,7.226c2.117,5.383,14.91,18.016,14.977,18.232.067-.216,12.861-12.849,14.977-18.232A10.185,10.185,0,0,0,30.924,6.032Z",
  transform: "translate(0 0)",
  fill: "#109dff"
});

function SvgPictoJaime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.491,
    height: 31.491,
    viewBox: "0 0 31.491 31.491",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoJaime);
export default __webpack_public_path__ + "static/media/picto_jaime.8dbe711a.svg";
export { ForwardRef as ReactComponent };